window.initializeSwiperWhenVisible('.block__about-us-result-count-wrp', () => {
  new Swiper('.block__about-us-result-count-wrp', {
    loop: true,
    slidesPerView: 1,
    effect: "fade",
    spaceBetween: 0,
    freeMode: false,
    autoplay: {
      delay: 7000,
    },
    fadeEffect: {
      crossFade: true,
    },
  });
});
